<template>
  <transition name="router-anim" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutDown">
    <div class="vld-parent">
      <loading :active="isLoading" :can-cancel="false" :is-full-page="true">
      </loading>
      <v-layout justify-center>
        <div style="width: 100%;">

          <v-card-title class="display-2  font-weight-thin text-blue">
           <v-container style="margin-left: 2px;">
            <v-row>                      
              <v-icon class="text-blue fontsize45 mdi mdi-widgets text-center pt-5" />  
              <span class="text-blue fontsize45">Dashboard</span>        
              <!-- <v-text class="text-blue fontsize45">Dashboard</v-text>           -->
            </v-row>
           </v-container>
           
            
            <v-spacer />
          </v-card-title>
          <v-container fluid grid-list-lg style="padding-left: 2px !important;">
            <v-row wrap>
              <v-col v-for="card in cards" v-bind="{ [`xs${card.flex}`]: true }" :key="card.title" col="6" md="6">
                <v-card hover style="padding:5px;">
                  <v-layout justify-center align-center @click="changeRoute(card.route)" :class="'ta-dashboard-'+card.title">
                    <!-- <v-col col="1" class="text-xs-left">
                        <br />
                      </v-col> -->
                    <v-col col="5" class="text-left">
                      <h1 class="text-h5 font-weight-light" v-bind:class="[{ 'text-green': card.title == 'Approved' },
                      { 'text-red': card.title == 'Failed' },
                      { 'text-orange': card.title == 'Pending' },
                      { 'text-purple': card.title == 'Declined' },
                      { 'text-red': card.title == 'Quotes' }]">
                        <v-icon v-bind:class="[{ 'text-green': card.title == 'Approved' },
                        { 'text-red': card.title == 'Failed' },
                        { 'text-orange': card.title == 'Pending' },
                        { 'text-purple': card.title == 'Declined' },
                        { 'text-red': card.title == 'Quotes' }]" size="larger">
                          {{ card.icon }}
                        </v-icon>
                        {{ card.title }}
                      </h1>
                      <br />
                      <span v-if="isFiltered" class="filtered text-grey">Filtered Results</span>
                      <!--    <span class="grey--text">
                        <v-icon color="green">done</v-icon>
                        Completed {{card.completed}}
                      </span>
                      <br>

                      <span class="grey--text">
                        <v-icon color="grey lighten-1">cached</v-icon>
                        Pending {{card.pending}}
                      </span>
                      <br>
                      <span class="grey--text">
                        <v-icon color="grey lighten-1">close</v-icon>
                        Rejected {{card.rejected}}
                        </span>-->
                    </v-col>
                    <br />
                    <v-col col="6">
                      <span justify-end>
                        <h1 class="text-h2 font-weight-thin">{{ card.count }}</h1>
                      </span>

                      <span v-if="card.title == 'Quotes'">
                        <span class="ma-2 circle" color="warning">
                          {{ card.countAlert ? card.countAlert : 0 }}
                        </span>
                        <br>
                        <span class="needReview"> Needs <br> Review </span>
                      </span>
                    </v-col>
                  </v-layout>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

        </div>
      </v-layout>
    </div>
  </transition>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import DataService from "@/services/data-service";
const dataService = new DataService();

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {
  AppSettingConfigurations,
  PendingAgreementConfigurations,
} from "../constants/index";
const CurrentAppSettings = AppSettingConfigurations.PendingAgreements;
export default {
  name: "dashboard",
  data: () => ({
    isLoading: false,
    cards: [
      {
        title: "Pending",
        value: "Pending",
        code: "RequestForChange",
        count: "0",
        pending: "0",
        completed: "0",
        rejected: "0",
        icon: "mdi-timelapse",
        //flex: 6,
        route: "/bookings/pending"
      },
      {
        title: "Approved",
        value: "Approved",
        code: "TicketSplit",
        count: "0",
        pending: "0",
        completed: "0",
        rejected: "0",
        icon: "mdi-check-circle-outline",
        //flex: 6,
        route: "/bookings/approved"
      },
      {
        title: "Declined",
        value: "Rejected",
        code: "Settlements",
        count: "0",
        pending: "0",
        completed: "0",
        rejected: "0",
        icon: "mdi-cancel",
        //flex: 6,
        route: "/bookings/declined"
      },
      {
        title: "Failed",
        value: "Failed",
        code: "OtherTicketAction",
        count: "0",
        pending: "0",
        completed: "0",
        rejected: "0",
        icon: "mdi-close-box-outline",
        //flex: 6,
        route: "/bookings/failed"
      },
      {
        title: "Quotes",
        value: "Quotes",
        color: "red",
        code: "OtherTicketAction",
        count: "0",
        pending: "0",
        completed: "0",
        rejected: "0",
        icon: "mdi-currency-usd",
        //flex: 6,
        route: "/bookings/Quotes"
      }
    ],
    SameBookingNumberConfig: false,
    isFiltered: false
  }),
  created() {
    this.isFiltered = localStorage.getItem("enablefilter") == "true";
    this.initialize();
  },
  components: {
    Loading
  },
  computed: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  methods: {
    initialize() {
      this.getActionsListRequestCount();
      this.getProRights();
      this.getAppSettings();
    },
    getActionsListRequestCount() {
      this.isLoading = true;
      dataService.getBookingOverview(
        "book,prepay,order",
        response => {
          console.log(response);
          this.isLoading = false;
          this.cards.forEach(card => {
            if (card.value !== "Quotes") {
              var filteredCard = response.find(x => x.Status === card.value);
              if (filteredCard) {
                card.count = filteredCard.Count;
              }
            }
          });
        },
        failure => { }
      );
      dataService.getBookingOverview(
        "quote",
        response => {
          console.log(response);
          let quoteIndx = this.cards.findIndex(x => x.value == "Quotes");
          var filteredCard = response.find(x => x.Status === "Pending");
          var filteredCardAlert = response.find(x => x.Status === "Alert");

          if (filteredCard || filteredCardAlert) {
            this.cards[quoteIndx].count = filteredCard.Count;
            this.cards[quoteIndx].countAlert = filteredCardAlert.Count;
          }
        },
        failure => { }
      );
    },
    changeRoute: function (routeNum) {
      this.$router.replace(routeNum);
    },
    getProRights() {

      dataService.getSalesProConfigurations(response => {
        console.log(response);
      },
        failure => { });
    },
    async getAppSettings() {
      try {

        let response = await dataService.GetAppSettingsByType(
          CurrentAppSettings
        );

        if (response && response.length) {

          this.SameBookingNumberConfig = response.find((x) => x.Name == PendingAgreementConfigurations.SameBookingNumber);

          if (this.SameBookingNumberConfig) {

            localStorage.setItem("isSameNumber", this.SameBookingNumberConfig.Value);
          } else {
            localStorage.setItem("isSameNumber", false);
          }

        }

        this.isLoading = false;
      } catch (ex) {
        console.log(ex);
        this.isLoading = false;
        this.snackbar = true;
        this.snackbarText = "Failed to fetch saved settings";
      }
    },



  }
};
</script>

<style scoped>
body {
  font-family: "Roboto", sans-serif;
}

.cell-font-size {
  font-size: 12px;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}

.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.oranged--text {
  color: orangered;
}

table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}

.fontsize45 {
  font-size: 45px !important;
}

.filtered {
  top: 60px;
  position: absolute;
  /* left: 105px; */
}

.circle {
  border-radius: 50%;
  font-size: 22pt;
  background-color: orange;
  color: white;
  padding: 0px 14px 0px 14px;
  bottom: 55px;
  position: absolute;
  right: 40px;
}

.needReview {
  font-size: 17px;
  right: 40px;
  position: absolute;
  bottom: 10px;
  font-weight: bold;
}
</style>
